// extracted by mini-css-extract-plugin
module.exports = {"card":"_9978","title":"_14697","primary":"_8635","icon":"_6017","list":"_11375","item":"_739","progress":"_17943","name":"_16614","desc":"_10593","time":"_3596"};